import { Component, OnDestroy, OnInit, ViewEncapsulation, } from '@angular/core';
import { configuration } from 'src/app/configuration';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ExcelService } from 'src/app/core/services/excel.service';
import { AppService } from 'src/app/core/services/app.service';
import { SwalService } from 'src/app/core/services/swal.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventEmitterService } from '../../../../core/services/event-emitter.service';
import swal from 'sweetalert2';
import {AppConfigService} from "../../../../core/services/config.service";
const API_URL = configuration.apiUrl;
const FILE_URL = configuration.fileUrl;

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .dark-modal .modal-content {
        background-color: #292b2c;
        color: white;
      }
      .dark-modal .close {
        color: white;
      }
      .light-blue-backdrop {
        background-color: #5cb3fd;
      }
    `,
  ],
})

export class ReportingComponent implements OnInit, OnDestroy {
  API_URL: any;
  typeFiche: any;
  direction: any;
  selectedDirection: any;
  selectedStructure: any;
  settingsDirection = {};
  settingsStructure = {};
  listDirection: any = [];
  listStructure: any = [];
  matricule: any;
  listAgent: any;
  loaderText: any;
  nbre_agents: any;
  vueListAgent = false;
   key = 'nom';
  reverse = false;
  p = 1;
  filter: string;
  id_direction: any;
  code_direction: any;
  id_structure: any;
  code_structure: any;
  response: any;
  intervalId = 0;
  message = '';
  seconds = 30;
  constructor(
    private _service: AppService,
    private configService: AppConfigService,
    private _loader: LoadingBarService,
    private _excelService: ExcelService,
    private _swal: SwalService,
    private eventEmitter: EventEmitterService,
    private _router: Router,
    private title: Title,
    private storage: LocalStorageService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.API_URL = configService.get('HOST_API_ONLINE');
  }

  ngOnInit() {
    this.getAllDirection();
    this.getAllStructure();
    this.title.setTitle('Reporting EIA | HR Performance');
    this.settingsDirection = {
      singleSelection: true,
      text: 'Selectionner la direction',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune direction disponible'
    };

    this.settingsStructure = {
      singleSelection: true,
      text: 'Selectionner la structure',
      classes: 'myclass custom-class',
      labelKey: 'code',
      enableSearchFilter: true,
      searchBy: ['code'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucune structure disponible'
    };
  }

  ngOnDestroy() { this.clearTimer(); }

  ouvrirFiche(data, type_fiche, type_sauvegarde, category) {
    // tslint:disable-next-line: max-line-length
    this._router.navigateByUrl(`campagne/reporting-eia/agent/${data?.id}/${data?.agent_id}/type_fiche/${type_fiche}/type_sauvegarde/${type_sauvegarde}/${category}/statut/approuvé`);
  }

  exportFiche(data, type) {
    this._loader.start();
    if (type === 'excel') {
      window.open(this.API_URL + 'fiche/' + data.id + '/export/type/normal', '_blank');
    } else {
      window.open(this.API_URL + 'fiche/export/' + data.id + '/normal/fiche-complete', '_blank');
    }
    this._loader.stop();
  }

  getAllDirection() {
    this._loader.start();
    this._service.getData('capital-humain/structures/direction')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loader.stop();
            this.listDirection = res.data;
          } else {
            this._loader.stop();
            this._swal.error(res.message);
          }
        }, err => {
          this._loader.stop();
          this.toastrService.error(err.error.message);
        }
      );
  }

  // Get all structure
  getAllStructure() {
    this._loader.start();
    this._service.postData('capital-humain/structures/all', {}).subscribe((data: {}) => {
      this._loader.stop();
      this.response = data;
      this.listStructure = this.response.data;
    });
  }

  onSelectDirection(item) {
    this.id_direction = item.id;
    this.code_direction = item.code;
  }

  onSelectStructure(item) {
    this.id_structure = item.id;
    this.code_structure = item.code;
  }

  onDeSelectItem(item, type) {
    if (type === 'direction') {
      this.id_direction = '';
      this.code_direction = '';
    } else {
      this.id_structure = '';
      this.code_structure = '';
    }
  }

  clearTimer() { clearInterval(this.intervalId); }

  start() { this.countDown(); }
  stop() {
    this.clearTimer();
    this.message = `Géneration du fichier dans ${this.seconds} secondes`;
  }

  exporterAllFiche() {
    this._loader.start();
    const obj = {
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
      code_direction: this.code_direction,
      code_structure: this.code_structure,
    };
    this._service.postData('reporting/zip_fiche_direction', obj).subscribe(
      (res) => {
        if (res.error === false) {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            type: 'success',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          }).then((result) => {
            if (result.value) {
              if (this.code_direction && !this.code_structure) {
                this.eventEmitter.onGetFileDirection();
                this.storage.store('code_direction', this.code_direction);
              } else {
                this.eventEmitter.onGetFileStructure();
                this.storage.store('code_direction', this.code_direction);
              };
            }
          });
        } else {
          this._loader.stop();
          swal.fire({
            title: 'HR PERF',
            type: 'warning',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
        }
      },
      (err) => {
        this.toastrService.error(err.error.message);
        this._loader.stop();
      }
    );
  }

  private countDown() {
    this.clearTimer();
    this.intervalId = window.setInterval(() => {
      this.seconds -= 1;
      if (this.seconds === 0) {
        this._loader.stop();

      } else {
        this._loader.start();
        if (this.seconds < 0) { this.seconds = 30; } // reset
      }
    }, 1000);
  }

  exportXls() {
    this._loader.start();
    const arrayAgent = [];
    for (let i = 0; i < this.listAgent.length; i++) {
      arrayAgent.push(
        {
          'Matricule': this.listAgent[i].matricule,
          'Nom & Prénoms': this.listAgent[i].nom + ' ' + this.listAgent[i].prenoms,
          'Direction': this.listAgent[i].direction,
          'Service': this.listAgent[i].service,
          'Section': this.listAgent[i].section,
          'Sous-Section': this.listAgent[i].sous_section,
          'Tenue de poste': this.listAgent[i].resultat_synthese_competence,
          'Performance': this.listAgent[i].resultat_synthese_performance,
          'Resultat global': this.listAgent[i].resultat_global,
          'Appréciation global': this.listAgent[i].appreciation_global
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayAgent, 'reporting_recherche_agent');
    this._loader.stop();
  }

  exportCommentaire() {
    this._loader.start();
    const arrayAgent = [];
    for (let i = 0; i < this.listAgent.length; i++) {
      arrayAgent.push(
        {
          'Matricule': this.listAgent[i].matricule,
          'Nom & Prénoms': this.listAgent[i].nom + ' ' + this.listAgent[i].prenoms,
          'Direction': this.listAgent[i].direction,
          'Service': this.listAgent[i].service,
          'Commentaire agent': this.listAgent[i].commentaire_agent,
          'Commentaire N+1': this.listAgent[i].commentaire_nplus_1,
          'Commentaire N+2': this.listAgent[i].commentaire_nplus_2
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayAgent, 'reporting_commentaire_hierarchie');
    this._loader.stop();
  }

  rechercher() {
    this._loader.start();
    const obj = {
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
      code_direction: this.code_direction,
      code_structure: this.code_structure,
      matricule: this.matricule,
    };
    this._service.postData('reporting/fiche_agent', obj).subscribe(
      (res) => {
        if (res.error === false) {
          this._loader.stop();
          this.listAgent = res.data;
          this.nbre_agents = this.listAgent.length;
          if (this.listAgent.length <= 0) {
            swal.fire({
              title: 'HR PERF',
              type: 'warning',
              text: 'Aucune donnée disponible',
              showCancelButton: false,
              confirmButtonText: 'ok',
            });
          } else {
            this.vueListAgent = true;
          }
        } else {
          swal.fire({
            title: 'HR PERF',
            type: 'warning',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this._loader.stop();
          this.vueListAgent = false;
        }
      },
      (err) => {
        this.toastrService.error(err.error.message);
        this._loader.stop();
        this.vueListAgent = false;
      }
    );
  }

}
